import ContentUtils from "@js/utils/content-utils.es6.js";
import Element from "@js/core/element.es6.js"

export default class ContentType extends Element {
  constructor({ machineName, parentElement }) {
    const className = ContentUtils.contentTypeMachineNameToClassName(
      machineName,
    );
    const selector = `.${className}`;
    super({ parentElement, selector });
  }
}
